export default "__VITE_ASSET__75180d25__"